import React, { useState, useEffect } from "react";
import axios from "axios";
import { Card, CardContent, CardHeader, CardTitle } from "../../../components/ui/card";
import { Zap } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || window.location.origin;
const API = `${BACKEND_URL}/api`;

const fmtEur = (n) =>
  new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(Number(n || 0));

/**
 * Express Metric Widget — share of orders paid via Express Checkout
 * (Apple Pay / Google Pay / Link) over the last 30 days.
 */
export const ExpressMetricWidget = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const fetchData = async () => {
      try {
        const token = sessionStorage.getItem("access_token");
        const res = await axios.get(`${API}/dashboard/express-stats`, {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        });
        if (!cancelled) setData(res.data);
      } catch (e) {
        if (!cancelled) setError(true);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    fetchData();
    return () => { cancelled = true; };
  }, []);

  return (
    <Card data-testid="express-metric-widget">
      <CardHeader className="pb-2">
        <CardTitle className="text-base flex items-center gap-2">
          <Zap className="w-4 h-4 text-amber-500" />
          Ordini Express — ultimi 30 giorni
          <span className="text-xs font-normal text-gray-400">(Apple Pay · Google Pay · Link)</span>
        </CardTitle>
      </CardHeader>
      <CardContent>
        {loading ? (
          <div className="text-sm text-gray-400 py-3">Caricamento…</div>
        ) : error || !data ? (
          <div className="text-sm text-red-500 py-3" data-testid="express-metric-error">
            Impossibile caricare le statistiche express
          </div>
        ) : (
          <div className="flex items-center gap-6 flex-wrap">
            <div>
              <div className="text-3xl font-bold text-amber-600" data-testid="express-percent">
                {data.percent}%
              </div>
              <div className="text-xs text-gray-500">degli ordini totali</div>
            </div>
            <div>
              <div className="text-xl font-semibold" data-testid="express-count">
                {data.express_orders} / {data.total_orders}
              </div>
              <div className="text-xs text-gray-500">ordini express / totali</div>
            </div>
            <div>
              <div className="text-xl font-semibold text-emerald-600" data-testid="express-revenue">
                {fmtEur(data.express_revenue)}
              </div>
              <div className="text-xs text-gray-500">incasso express 30gg</div>
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
};
